export const SELECT_ALL_LABEL = "Välj alla";
